import React from 'react';
import { string } from 'prop-types';

const DEBreadcrumb = ({ parent, child }) => {
  return (
    <div className="de--breadcrumb">
      <div>
        <span className="parent">{parent}</span>
        <span className="current">{child}</span>
      </div>
    </div>
  );
};

DEBreadcrumb.propTypes = {
  parent: string,
  child: string,
};

export default DEBreadcrumb;
